import styles from "../assets/styles/componenets/footer.module.css";
import logo from "../assets/images/scale.svg";

export default function Footer() {
    return (
        <footer className={styles.container}>
            <hr />
            <div className={styles.grid}>
                <div className={styles.brand}>
                    <img src={logo} alt="justice scale" />
                    <span>JUSTLAW</span>
                    <p>Shaping the Future of Legal Minds.</p>
                </div>

                <div className={styles.links}>
                    <h3>Հղումներ</h3>
                    <a href="#lessons">Դասընթացներ</a>
                    <a href="#teachers">Դասախոսներ</a>
                    <a href="#contact-us">Հետադարձ կապ</a>
                </div>

                <div className={styles.followUs}>
                    <h3>Follow Us</h3>
                    <div className={styles.socialIcons}>
                        <a href="https://facebook.com/61572931420108/" target="_blank" rel="noreferrer">
                            <i className="fa-brands fa-facebook"></i>
                        </a>
                        <a href="https://www.instagram.com/just_law2025/" target="_blank" rel="noreferrer">
                            <i className="fa-brands fa-instagram"></i>
                        </a>
                    </div>
                </div>
            </div>

            <hr />

            <div className={styles.bottomSection}>
                <p>&copy; 2025 JUSTLAW. All rights reserved.</p>
            </div>
        </footer>
    );
}


/**Where Legal Knowledge Meets Excellence. */